import type { AppRoute } from 'src/routes/types';

import { lazy } from 'react';

const ClientVaultView = lazy(() => import('./views/ClientVaultView.tsx'));
const ClientVaultDocumentEditor = lazy(
  () => import('./views/ClientVaultDocumentEditor.tsx')
);

const clientRoutePaths = {
  clientVaultDocumentEditor: '/care/client/:id/vault/editor/:fileId',
  clientVaultFolder: '/clients/:id/vault/folder/:folderId',
  clientVaultRoot: '/clients/:id/vault',
} as const;

const clientRoutes: AppRoute[] = [
  {
    _dangerouslyInjectAsChildForLegacyPath: 'clients/:id',
    element: <ClientVaultView />,
    enabled: true,
    path: clientRoutePaths.clientVaultRoot,
    permission: 'all',
    scope: 'private',
  },
  {
    _dangerouslyInjectAsChildForLegacyPath: 'clients/:id',
    element: <ClientVaultView />,
    enabled: true,
    path: clientRoutePaths.clientVaultFolder,
    permission: 'all',
    scope: 'private',
  },
  {
    element: <ClientVaultDocumentEditor />,
    enabled: true,
    path: clientRoutePaths.clientVaultDocumentEditor,
    permission: 'all',
    scope: 'private',
  },
];

const FosterFamilyVaultView = lazy(
  () => import('./views/FosterFamilyVaultView.tsx')
);
const FosterFamilyVaultDocumentEditor = lazy(
  () => import('./views/FosterFamilyVaultDocumentEditor.tsx')
);

const fosterFamilyRoutePaths = {
  fosterFamilyVaultDocumentEditor:
    '/care/foster-families/:id/vault/editor/:fileId',
  fosterFamilyVaultFolder: '/foster-families/:id/vault/folder/:folderId',
  fosterFamilyVaultRoot: '/foster-families/:id/vault',
} as const;

const fosterFamilyRoutes: AppRoute[] = [
  {
    _dangerouslyInjectAsChildForLegacyPath: 'foster-families/:id',
    element: <FosterFamilyVaultView />,
    enabled: true,
    path: fosterFamilyRoutePaths.fosterFamilyVaultRoot,
    permission: 'all',
    scope: 'private',
  },
  {
    _dangerouslyInjectAsChildForLegacyPath: 'foster-families/:id',
    element: <FosterFamilyVaultView />,
    enabled: true,
    path: fosterFamilyRoutePaths.fosterFamilyVaultFolder,
    permission: 'all',
    scope: 'private',
  },
  {
    element: <FosterFamilyVaultDocumentEditor />,
    enabled: true,
    path: fosterFamilyRoutePaths.fosterFamilyVaultDocumentEditor,
    permission: 'all',
    scope: 'private',
  },
];

export const careRoutePaths = {
  ...clientRoutePaths,
  ...fosterFamilyRoutePaths,
} as const;

export const careRoutes = [...clientRoutes, ...fosterFamilyRoutes];
